import {SlickSlider as Slider, SliderType as _SliderType} from "./src/SlickSlider";
export {slickStyles} from "./src/styles/slickSlider";

export type SliderType = _SliderType;

export default Slider;
import {SlickSlider as Slider, SliderType as _SliderType} from "./src/SlickSlider";
export {slickStyles} from "./src/styles/slickSlider";

export type SliderType = _SliderType;

export default Slider;
